<div *ngIf="!tableErrorCode" class="table-container">
  <div #tableWrapper (scroll)="onTableScroll()" class="table-wrapper">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th
          *ngFor="let header of tableHeader"
          [class]="{
              'tooltip-cell':
                header.key === 'redistributionOffer'
            }"
        >
          <div class="th-content">
            <p *ngIf="!isColumnFilterable(header.key)">{{ header.label }}</p>
            <app-tooltip
              *ngIf="header.key === 'redistributionOffer'"
              class="custom-tooltip"
              tooltip="Згідно постанови №298, пункт 15, перерозподіл одержаних товарів"
            />
            <app-filter
              (onError)="onFilterError($event)"
              (selectedOptionsChange)="onFilterChange($event)"
              (sortChange)="onSortChange($event)"
              *ngIf="isColumnFilterable(header.key)"
              [key]="filterKeys[header.key]"
              [preselectedOption]="getPreselectedOption(header.key)"
              [reset]="resetFilters"
              [sortKey]="sortKey"
            >{{ header.label }}
            </app-filter
            >
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngIf="!tableBodyErrorCode">
        <ng-container *ngFor="let row of tableBody; index as i">
          <ng-container *ngIf="row['subtype'] !== 'PACKAGE' || row['balanceQuantity'] === null || row['balanceQuantity'] === 0">
            <tr
                (click)="onRowClick($event, row)"
                (mouseout)="hoveredRow = null"
                (mouseover)="onRowHover(row)"
                [class.active]="activeRow === row"
                [class.hover]="hoveredRow === row"
            >
              <td
                  *ngFor="let cell of tableSubHeader"
                  [title]="getCellTitle(row[cell.key])"
                  [class.with-button]="cell.key === 'mnnName'"
              >
                {{ row[cell.key] | dateString | textEllipsis }}
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="row['subtype'] === 'PACKAGE' && row['balanceQuantity'] > 0">
            <ng-container>
              <tr
                  (click)="onRowClick($event, row)"
                  (mouseout)="hoveredRow = null"
                  (mouseover)="onRowHover(row)"
                  [class.active]="activeRow === row"
                  [class.hover]="hoveredRow === row"
                  [class.open]="isOpen(i)"
              >

                <td
                    *ngFor="let cell of tableSubHeader"
                    [title]="getCellTitle(row[cell.key])"
                    [class.with-button]="cell.key === 'mnnName'"
                >
                  <ng-container *ngIf="cell.key === 'mnnName'">
                    <button (click)="onToggleRow(i)" class="toggle-button" [class.open]="isOpen(i)">
                      <span>
                        <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.98535 1L6.00008 5L10.0148 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                    </button>
                  </ng-container>

                  {{ row[cell.key] | dateString | textEllipsis }}

                  <ng-container *ngIf="cell.key === 'minUnit'">
                    <span class="components-amount">{{ row['components'] ? row['components'].length : 0 }}</span>
                  </ng-container>

                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="isOpen(i)">
              <tr
                  *ngFor="let subRow of row['components']"
                  (mouseout)="hoveredRow = null"
                  (mouseover)="onRowHover(row)"
                  [class.active]="activeRow === row"
                  [class.hover]="hoveredRow === row"
                  class="card-details-row"
              >
                <td
                    *ngFor="let cell of tableSubHeader"
                    [title]="getCellTitle(row[cell.key])"
                    [class.with-button]="cell.key === 'mnnName'"
                >
                  {{ subRow[cell.key] | dateString | textEllipsis }}
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>


      </ng-container>
      <ng-container *ngIf="tableBodyErrorCode && tableBodyErrorCode !== 401">
        <tr>
          <td [attr.colspan]="13">
            <div class="error-cell-content">
              <app-error [errorCode]="tableBodyErrorCode"></app-error>
            </div>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div class="table-footer">
    <div class="left">
      <strong>Застосовані фільтри</strong> <span>{{ filtersAmount }}</span>
      <div (click)="onResetFilters()" class="icon-container">
        <med-icon-reset class="icon" size="16"></med-icon-reset>
      </div>
    </div>
    <div class="right">
      <med-pagination
        *ngIf="tableBody.length > 0 && !tableBodyErrorCode"
        (pageChange)="onPageChange($event)"
        [(page)]="pagination.page"
        [perPage]="pagination.perPage"
        [total]="pagination.totalElements"
      ></med-pagination>
    </div>
  </div>
</div>
<div *ngIf="tableErrorCode && tableErrorCode !== 401" class="error-container">
  <app-error [errorCode]="tableErrorCode"></app-error>
</div>
<app-modal-redistribution-create #modalRedistribution/>
<app-context-menu #contextMenu/>

